var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSync = function SvgSync(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 515.554 515.554",
    height: 512,
    viewBox: "0 0 515.554 515.554",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m96.666 257.778c0-77.635 55.647-141.267 128.889-156.322v27.433l96.667-64.444-96.667-64.445v34.968c-109.108 15.716-193.334 109.432-193.334 222.81 0 68.268 30.612 129.428 78.693 170.827l56.424-37.619c-42.608-29.023-70.672-77.885-70.672-133.208z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m404.639 86.951-56.424 37.619c42.608 29.022 70.673 77.885 70.673 133.208 0 77.731-55.535 142.223-128.891 157.26v-28.373l-96.667 64.444 96.667 64.444v-34.838c109.12-15.72 193.335-109.55 193.335-222.938.001-68.267-30.611-129.427-78.693-170.826z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSync, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sync.db9cea0a.svg";
export { ForwardRef as ReactComponent };